import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecentActivity = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'memorized':
        return { name: 'CheckCircle', color: 'var(--color-success)' };
      case 'practiced':
        return { name: 'Brain', color: 'var(--color-primary)' };
      case 'note_added':
        return { name: 'StickyNote', color: 'var(--color-accent)' };
      case 'verse_added':
        return { name: 'Plus', color: 'var(--color-warning)' };
      case 'streak_milestone':
        return { name: 'Flame', color: 'var(--color-success)' };
      case 'achievement':
        return { name: 'Award', color: 'var(--color-accent)' };
      default:
        return { name: 'Activity', color: 'var(--color-muted-foreground)' };
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffInHours = Math.floor((now - activityTime) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return 'Just now';
    if (diffInHours < 24) return `${diffInHours}h ago`;
    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays}d ago`;
  };

  return (
    <div className="bg-card rounded-xl p-6 shadow-warm border border-border">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-heading font-semibold text-foreground">Recent Activity</h2>
        <Button
          variant="ghost"
          size="sm"
          iconName="History"
          iconPosition="left"
        >
          View All
        </Button>
      </div>
      <div className="space-y-4">
        {activities?.length === 0 ? (
          <div className="text-center py-8">
            <div className="flex items-center justify-center w-12 h-12 bg-muted rounded-lg mx-auto mb-3">
              <Icon name="Activity" size={24} className="text-muted-foreground" />
            </div>
            <p className="text-sm text-muted-foreground mb-2">No recent activity</p>
            <p className="text-xs text-muted-foreground">
              Start memorizing verses to see your progress here
            </p>
          </div>
        ) : (
          activities?.map((activity) => {
            const iconConfig = getActivityIcon(activity?.type);
            
            return (
              <div
                key={activity?.id}
                className="flex items-start space-x-3 p-3 rounded-lg hover:bg-background/50 transition-colors duration-200"
              >
                <div className="flex items-center justify-center w-8 h-8 bg-muted rounded-lg flex-shrink-0">
                  <Icon name={iconConfig?.name} size={16} color={iconConfig?.color} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between">
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-foreground">
                        {activity?.title}
                      </p>
                      <p className="text-xs text-muted-foreground mt-1">
                        {activity?.description}
                      </p>
                      {activity?.verse && (
                        <div className="flex items-center space-x-2 mt-2">
                          <Icon name="Book" size={12} className="text-muted-foreground" />
                          <span className="text-xs font-caption text-primary">
                            {activity?.verse}
                          </span>
                        </div>
                      )}
                    </div>
                    <span className="text-xs text-muted-foreground flex-shrink-0 ml-2">
                      {formatTimeAgo(activity?.timestamp)}
                    </span>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
      {activities?.length > 0 && (
        <div className="mt-6 pt-4 border-t border-border">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">
              {activities?.length} recent activities
            </span>
            <Button
              variant="ghost"
              size="sm"
              iconName="ArrowRight"
              iconPosition="right"
            >
              See More
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecentActivity;